import React, {useState} from 'react';
import {Col, Container, Row, Tab, Nav} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";
import Img1 from "../../../images/lp/Access.png";
import Img2 from "../../../images/lp/scale.png";
import Img3 from "../../../images/lp/cost.png";
import Img4 from "../../../images/lp/faster.png";
import Img5 from "../../../images/lp/flex.png";
import Img6 from "../../../images/lp/Api.png";
import Img7 from "../../../images/lp/cases.png";

function Aikeypoints(props) {
    const [activeTab, setActiveTab] = useState("0");

    const handleTabSelect = (eventKey) => {
        setActiveTab(eventKey);
    };

    return (
        <section className="tekgrip_section tekrevol_gray_bg p-100 key-points">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={7} xxl={7} className="my-auto">
                        <div className="example" data-text="Key Points">
                            <h2>Discover the Power of AI Delivered as a Service (AIaaS)</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="tekgrip_tabs">
                        <Tab.Container defaultActiveKey="0" id="my-tab-switcher" activeKey={activeTab}
                                       onSelect={handleTabSelect}>
                            <Row>
                                <Col xs={12} md={4} lg={5} xl={5}>
                                    <Nav variant="pills" className="flex-column">
                                        <Nav.Item>
                                            <Nav.Link eventKey="0">Accessibility</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="1">Scalability</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="2">Cost-Efficiency</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="3">Faster Deployment</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="4">Flexibility</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="5">APIs and Integration</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="6">Use Cases</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                                <Col xs={12} md={4} lg={3} xl={3}>
                                    <Tab.Content>
                                        <Tab.Pane eventKey="0">
                                            <h6>Accessibility</h6>
                                            <p>Effortlessly access powerful AI tools without technical barricades. Our AI as a Service (AIaaS) platform guarantees that you can tap into front-line AI capabilities irrespective of your technical expertise. Whether you're an experienced AI professional or new to the field, our intelligible interface makes AI available to everyone.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="1">
                                            <h6>Scalability</h6>
                                            <p>Scale your AI resources smoothly as your requirements grow. With our AIaaS solution, you're not restricted by fixed infrastructure. As your business grows, our platform impeccably accommodates augmented AI demands, warranting optimal performance and results without the requirement for compound adjustments.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="2">
                                            <h6>Cost-Efficiency</h6>
                                            <p>Embrace AI's potential without emptying the bank. Traditional AI adoption frequently come with heavy upfront costs. AIaaS transforms this by providing a cost-effective model. Pay only for the AI resources you use, decreasing monetary barriers and making AI implementation financially feasible for businesses of all sizes.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="3">
                                            <h6>Faster Deployment</h6>
                                            <p>Swiftly deploy AI solutions for instant impact. Time-to-market is crucial, and AIaaS hastens this process. With pre-configured AI tools and resources, you can position AI solutions speedily, guaranteeing you earn the benefits of AI without protracted development timelines.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="4">
                                            <h6>Flexibility</h6>
                                            <p>Modify AI applications to ensemble your unique business requirements. AIaaS isn't a one-size-fits-all method. Modify AI functionalities to align with your detailed requirements. Our platform authorizes you to mold AI to boost your operations, whether it's customer service, product development, or data analysis.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="5">
                                            <h6>APIs and Integration</h6>
                                            <p>Easily integrate AI capabilities into your current workflows. Flawlessly merge AI functionalities into your current systems with our strong APIs and integration options. Connect AI with your software and tools, producing a consistent ecosystem that intensifies your capabilities without unsettling your conventional processes.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="6">
                                            <h6>Use Cases</h6>
                                            <p>Discover assorted applications, from data analysis to automation. AIaaS spreads its assistances across industries. Evaluate vast datasets rapidly, automate repetitive tasks, improve customer experiences through adapted interactions—the possibilities are boundless. Discover how AIaaS can revolutionize your sector.</p>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                                <Col xs={12} md={4} lg={4} xl={4} className="my-auto">
                                    <Tab.Content>
                                        <Tab.Pane eventKey="0">
                                            <LazyLoadImage
                                                src={Img1}
                                                effect="blur" alt="Image" className="img-fluid"
                                            />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="1">
                                            <LazyLoadImage
                                                src={Img2}
                                                effect="blur" alt="Image" className="img-fluid"
                                            />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="2">
                                            <LazyLoadImage
                                                src={Img3}
                                                effect="blur" alt="Image" className="img-fluid"
                                            />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="3">
                                            <LazyLoadImage
                                                src={Img4}
                                                effect="blur" alt="Image" className="img-fluid"
                                            />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="4">
                                            <LazyLoadImage
                                                src={Img5}
                                                effect="blur" alt="Image" className="img-fluid"
                                            />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="5">
                                            <LazyLoadImage
                                                src={Img6}
                                                effect="blur" alt="Image" className="img-fluid"
                                            />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="6">
                                            <LazyLoadImage
                                                src={Img7}
                                                effect="blur" alt="Image" className="img-fluid"
                                            />
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>

                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Aikeypoints;